// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1Cxkn","content":"ManualTimeModal_content__2ReIR"};